import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFeature, useGrowthBook } from '@growthbook/growthbook-react';

import FEATURES from '../../constants/featureToggling';

import { useRecentGame } from '../../pages/Dashboard/hooks';
import {
  isLoggedInSelector,
  userNumberSelector,
} from '../../redux/reducers/app/params';
import { useIsDesktopLayout } from '../useMediaQuery';
import { useCommonAppStoreReviewMode } from '../useAppStoreReviewMode';
import { commonConfigurationSelector } from '../../redux/reducers/app/configuration';
import { getSegmentsDataKey, getUserSegmentsData } from '../../utils/segments';
import { getWidgets } from './utils';

export const useWidgets = (widgetsMap) => {
  const growthbook = useGrowthBook();
  const commonConfig = useSelector(commonConfigurationSelector);
  const isOrderingEnabled = useFeature(FEATURES.AMS_ORDERING).on;
  const isLoggedIn = useSelector(isLoggedInSelector);
  const userNumber = useSelector(userNumberSelector);
  const isDesktop = useIsDesktopLayout();
  const isCommonAppStoreReviewMode = useCommonAppStoreReviewMode();
  const {
    isLoading,
    recentGame,
    recentGameId,
    recentGameThemeId,
    recentGameProviderId,
  } = useRecentGame({ enabled: isLoggedIn });

  return useMemo(() => {
    if (isLoading) return [];

    const localStorageKey = getSegmentsDataKey(userNumber);
    const { segments } = getUserSegmentsData(localStorageKey);

    return getWidgets({
      widgetsMap,
      isDesktop,
      growthbook,
      isLoggedIn,
      commonConfig,
      segments,
      recentGame,
      recentGameId,
      recentGameThemeId,
      recentGameProviderId,
      isCommonAppStoreReviewMode,
      isOrderingEnabled,
    });
  }, [
    widgetsMap,
    isDesktop,
    growthbook,
    isLoggedIn,
    commonConfig,
    userNumber,
    isLoading,
    recentGame,
    recentGameId,
    recentGameThemeId,
    recentGameProviderId,
    isCommonAppStoreReviewMode,
    isOrderingEnabled,
  ]);
};
